
import Vue from "vue";
import store from "@/store";

export default Vue.extend({
  computed: {},
  methods: {
    showAlertError(message: string) {
      store.dispatch.alertModule.showAlertError(message);
    },
    showAlertMessage(message: string, alertType: string) {
      let options = { message: message, alertType: alertType };
      store.dispatch.alertModule.showAlertMessage(options);
    },
  },
});
